import { ThemeTree, ThemeTreeResponse } from 'types/chatSettings';

export const transformThemeTreeResponse = (
  themeTreeResponse: ThemeTreeResponse,
): ThemeTree => {
  const { data, customFields } = themeTreeResponse;
  return {
    id: data.id,
    name: data.name,
    childrenLabel: data.childrenLabel,
    children: data.children,
    themeOptions: customFields,
  };
};
